<template>
    <div class="container mt-4" v-if="$isAllowed('read')">
        <functional-modal></functional-modal>
        <div class="row">
            <div class="col-12">
                <cph-widget>
                    <h2 slot="header">{{$t('PRINTERS.printers')}}</h2>
                    <div class="row" slot="body" v-for="(item, index) in cubes"
                         :key="`item-index-${index}-${item.ip}`"  v-if="cubes">
                        <printer-tile v-for="(printer, index2) in item.printers"
                                      :ip="item.ip"
                                      :key="`printer-item-index${index2}-${item.ip}`"
                                      @open="editing = true; selectedPrinter = item"
                                      :printer="printer">
                        </printer-tile>
                    </div>
                </cph-widget>
            </div>
            <functional-modal @close="editing = false"
                              :showModal="editing"
                              :title="$t('UI.edit')">
                <div :class="['col-12']" slot="body">
                    <printer-maintenance :printer="selectedPrinter"></printer-maintenance>
                </div>
            </functional-modal>
        </div>
    </div>
</template>

<script type="text/babel">
import FunctionalModal from '../../../components/Shared/Modal/FunctionalModal.vue';
import CphWidget from '../../../components/Shared/CphWidget.vue';
import PrinterTile from '../../../components/Panel/Printers/PrinterTile/PrinterTile.vue';
import PrinterMaintenance from '../../../components/Panel/Printers/PrinterMaintenance/PrinterMaintenance.vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { PrintersPerimeter } from '../../../router/perimeters/printersPerimeter';
import CphButton from '../../../components/Shared/UI/Button/CphButton.vue';

export default {
    name: 'PrintersView',
    data () {
        return {
            editing: false,
            selectedPrinter: {},
            cubes: []
        };
    },
    components: {
        FunctionalModal,
        CphWidget,
        CphButton,
        PrinterTile,
        PrinterMaintenance
    },
    perimeters: [
        PrintersPerimeter
    ],
    computed: {
        ...mapGetters({
            printers: 'getPrinters'
        })
    },
    methods: {
        ...mapMutations(['updateLoadingState']),
        ...mapActions([
            'getPrintersAsync',
            'findCubesAsync'
        ]),
        async fetchData () {
            this.updateLoadingState(true);
    
            try {
                let cubesIpList = ['', ...await this.findCubesAsync()];
                let res = await this.$utils.resolvePromises(cubesIpList.map(ip => this.getPrintersAsync(ip)));
                this.cubes = this.$utils.flatten(res);
            } catch (err) {
                this.cubes = [await this.getPrintersAsync('')];
                throw new Error(err);
            } finally {
                this.updateLoadingState(false);
            }
        }
    },
    created () {
        this.fetchData();
    }
};
</script>

<style lang="scss" scoped>
    .connected {
        background-color: #64bd63;
    }
    
    .disconnected {
        background-color: #dd5826;
    }
    
    .jammed {
        background-color: #f0b518;
    }
</style>
